function VideoPopup(){

	this.$popup = jQuery('.video-popup');
	this.init  = () => {
		if(!this.$popup)
			return;

		this.$popup.on('click', this.close);
		this.$popup.find('.video-popup__close').on('click', this.close);
		this.$popup.find('.video-popup__content').on('click', (ev) => {ev.stopPropagation();});
	}

	this.open = (src, title) => {
		this.$popup.find('.video-popup__title').text(title);
		this.$popup.find('.video-popup__video').attr('src', src);
		this.$popup.addClass('active');
	}

	this.close = () => {
		this.$popup.find('.video-popup__video').attr('src', '#');
		this.$popup.removeClass('active');
	}



}
export default new VideoPopup();
